import { Show } from 'solid-js';
import { CompanyBusinessMode } from '~/swagger/portal/Api';

const isHoa = (mode: CompanyBusinessMode | undefined) => mode === CompanyBusinessMode.Hoa;

// Literal type labels — deliberately NOT run through t(), because the HOA label
// overrides remap "Property" -> "HOA" in HOA mode, which would make every badge
// read "HOA". The badge must always show the company's true type.
export const CompanyTypeBadge = (props: { businessMode: CompanyBusinessMode | undefined }) => {
  return (
    <Show when={props.businessMode}>
      <span
        class="shrink-0 rounded-full px-2 py-0.5 text-xxs font-semibold uppercase leading-none"
        classList={{
          'bg-[#1F8A6A]/12 text-[#1F8A6A]': isHoa(props.businessMode),
          'bg-text-level03/12 text-text-level03': !isHoa(props.businessMode),
        }}>
        {isHoa(props.businessMode) ? 'HOA' : 'Property'}
      </span>
    </Show>
  );
};
